/// Мониторинг ошибок (Sentry).
///
/// DSN задаётся сборке через `VITE_SENTRY_DSN`; без DSN Sentry выключен и
/// приложение работает как обычно — ровно как во Flutter-версии.
export async function initMonitoring(): Promise<void> {
  const dsn = (import.meta.env.VITE_SENTRY_DSN ?? '').trim()
  if (!dsn) return

  try {
    // Грузим ленивo: без DSN пакет не попадает в стартовый чанк.
    const Sentry = await import('@sentry/react')
    Sentry.init({
      dsn,
      environment: import.meta.env.VITE_SENTRY_ENV || 'production',
      tracesSampleRate: 0.2,
      sendDefaultPii: false,
    })
  } catch {
    // Best-effort: сбой инициализации Sentry не должен ломать админку.
  }
}
